import { useEffect, useState } from "react";
import CalendarHeader from "src/Components/Calendar/CalendarHeader";
import CalendarGrid from "src/Components/Calendar/CalendarGrid";
import { getWeekNumberInMonth, getMajorityMonthOfWeek, getStartOfWeek } from "src/Common/common";
import WOService from "src/Services/API/wo.service";
import { handleError } from "src/Common/function";
import BranchBar from "src/Components/branchbar/BranchBar";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

function Calendar() {
  const today = new Date();
  const [currentDate, setCurrentDate] = useState(today);
  const [view, setView] = useState("Month");

  const weekStartDate = getStartOfWeek(currentDate);

  // const branch = useSelector((state) => state.Branch.branch);
  const [searchParams] = useSearchParams();
  const branch = Number(searchParams.get("branch"));

  // Determine majority month/week for header and week number
  const { year, month } =
    view === "Week"
      ? getMajorityMonthOfWeek(weekStartDate)
      : {
          year: currentDate.getFullYear(),
          month: currentDate.getMonth(),
        };

  const monthName = new Date(year, month).toLocaleDateString("default", {
    month: "long",
  });

  const weekNumber = view === "Week" ? getWeekNumberInMonth(weekStartDate, month, year) : null;

  const [workOrders, setWorkOrders] = useState([]);

  useEffect(() => {
    WOService.getWOsForCalendar(view, year, month, weekNumber, branch)
      .then((response) => {
        if (response.status == 200) {
          console.log("workorder ==> ", response.data);
          setWorkOrders(response.data);
        }
      })
      .catch((error) => {
        handleError(error);
      });
  }, [month, year, weekNumber, branch]);

  const handlePrev = () => {
    const newDate = new Date(currentDate);
    newDate.setDate(view === "Month" ? 1 : newDate.getDate() - 7);
    if (view === "Month") {
      newDate.setMonth(currentDate.getMonth() - 1);
    }
    setCurrentDate(newDate);
  };

  const handleNext = () => {
    const newDate = new Date(currentDate);
    newDate.setDate(view === "Month" ? 1 : newDate.getDate() + 7);
    if (view === "Month") {
      newDate.setMonth(currentDate.getMonth() + 1);
    }
    setCurrentDate(newDate);
  };

  const handleView = (selectedView) => {
    setView(selectedView);
  };

  return (
    <div className="w-full h-full bg-backgroundColor px-6 pt-2">
      <BranchBar allEnabled={false} />
      <div className="h-3" />
      <CalendarHeader
        month={monthName}
        year={year}
        week={weekNumber}
        view={view}
        onPrev={handlePrev}
        onNext={handleNext}
        onView={handleView}
      />
      <CalendarGrid month={month} year={year} week={weekNumber} view={view} workOrders={workOrders} />
    </div>
  );
}

export default Calendar;
